import { useDispatch, useSelector } from "react-redux";
import { selectProfile } from "redux/reducers/session";
import french from "localization/fr.json";
import { useCallback, useEffect } from "react";
import {
  selectBrowserLanguage,
  selectPublicPagePreferredLanguage
} from "redux/localization/selectors";
import {
  browserLanguageChanged,
  publicPagePreferredLanguageSelected
} from "redux/localization/actions";

export default function useLocalization() {

  const dispatch = useDispatch()

  const syncPreferredPublicPageLanguage = useCallback(language => {
    dispatch(publicPagePreferredLanguageSelected(language))
  }, [dispatch])

  useEffect(() => {
    const language = localStorage.getItem(PREFERRED_PUBLIC_PAGE_LANGUAGE)
    syncPreferredPublicPageLanguage(language)
  }, [syncPreferredPublicPageLanguage])

  const syncBrowserLanguage = useCallback(() => {
    dispatch(browserLanguageChanged(new Intl.Locale(navigator.language).language))
  }, [dispatch])

  useEffect(() => {
    syncBrowserLanguage()
    window.addEventListener('languagechange', syncBrowserLanguage);
    return () => window.removeEventListener('languagechange', syncBrowserLanguage)
  }, [syncBrowserLanguage])

  const userPreferredLanguage = AS_STANDARD_CODE[useSelector(selectProfile)?.language]
  const publicPagePreferredLanguage = useSelector(selectPublicPagePreferredLanguage)
  const browserLanguage = useSelector(selectBrowserLanguage)

  const locale = userPreferredLanguage ||
    publicPagePreferredLanguage ||
    browserLanguage ||
    DEFAULT_LANGUAGE

  const copy = locale === "fr" ? french : null

  const setPublicPageLanguage = useCallback(language => {
    localStorage.setItem(PREFERRED_PUBLIC_PAGE_LANGUAGE, language)
    syncPreferredPublicPageLanguage(language)
  }, [syncPreferredPublicPageLanguage])

  return { locale, copy, setPublicPageLanguage }
}

export function standardCodeFromLanguageString(language) {
  return AS_STANDARD_CODE[language.toUpperCase()];
};

const AS_STANDARD_CODE = {
  "ENGLISH": "en",
  "FRENCH": "fr",
}
export const DEFAULT_LANGUAGE = AS_STANDARD_CODE["ENGLISH"]

export const PREFERRED_PUBLIC_PAGE_LANGUAGE = "preferred-public-page-language"